// Translation: Account > Integrations > Access keys > Access key deletion dialog (Russian)
export default Object.freeze({
	actions: {
		cancel: '',
		delete: ''
	},
	message: {
		text: '',
		title: ''
	}
})
